export class CarveOutDeleteCommand{
    carveOutId:string;

    constructor(carveOutId:string){
        this.carveOutId = carveOutId;
    }
}